// extracted by mini-css-extract-plugin
module.exports = {"title":"AwsCurSchedular-module__title__3FJzw","data":"AwsCurSchedular-module__data__xZrsS"};